import { useId } from 'react';
import type { ILabeledSelectProps } from '@/@types/photostudio';
import { cn } from '@/lib/utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function LabeledSelect({
  label,
  value,
  onChange,
  options,
  placeholder = 'Select...',
  disabled = false,
}: ILabeledSelectProps) {
  const id = useId();

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <label
        htmlFor={id}
        className="text-[11px] font-semibold uppercase tracking-wider text-accent"
      >
        {label}
      </label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          id={id}
          className={cn(
            'h-10 w-full',
            'bg-background-input border-border',
            'text-foreground',
            'hover:border-border-hover',
            'focus:border-accent',
            !value && 'text-foreground-placeholder'
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-popover border-border">
          {options.map(option => (
            <SelectItem
              key={option}
              value={option}
              className="text-popover-foreground hover:bg-muted focus:bg-muted"
            >
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
